import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../../api/Service';
import { getErrorMessage } from '../../../components/utils/errorHandler';
import { toast } from 'react-toastify';

export default function* watcherGetProductCategoriesSaga() {
    yield takeEvery("LOAD_PRODUCT_CATEGORY", workerSaga);
}

function* workerSaga(action) {
    try {
        yield put({ type: "DISPLAY_LOADER", payload: payload })
        var payload = {}
        const formatUrl = `api/Admin/get-product-category/${action.payload.companyId}`
        yield request("get", payload, formatUrl).then(response => {
            payload = response;
        });

        yield put({ type: "PRODUCT_CATEGORY_LIST", payload: payload})
        yield put({ type: "DISPLAY_LOADER", payload: payload })
           
    } catch (e) {
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        console.log("product-category-saga", e)
        console.log("product-category-saga", e.response)
        //  yield put({ type: "DISPLAY_LOADER" });
        console.log(e.response)
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
        yield put({ type: "DISPLAY_LOADER", payload: payload })

    }
}
